import { BOT_MODE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { getUserWebAttributeObject, LOGGER, readFromLs, updateBotLanguageToLS, writeToLs } from 'helpers/helpers';
import { botResponse, emitAskUserIdEvent, emitWelcomeMsg, isOldUser, updateChatEvent } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import socketIO from 'socket.io-client';
import { getGenericStringsAndBotConfig } from '../index';
import { chatHistoryPublish, playLiveChatNotfication } from './conversation';

class EngtSocket {
	constructor() {
		if (!EngtSocket.instance) {
			EngtSocket.instance = this;

			this.connect();
		}

		return EngtSocket.instance;
	}

	connect = function () {
		this.socket = socketIO.connect(ENGT_CHAT.get('config.brandedServer'), {
			path: `/socket.io/v2/${ENGT_CHAT.get('config.bot_key')}`,
			transports: ['websocket', 'polling'],
			query: { session_id: ENGT_CHAT.get('status.sessionKey').substring(0, 2) },
		});

		const self = this;

		return this.socket.on('connect', () => {
			LOGGER('Socket connected ', ENGT_CHAT, self.socket.id);
			ENGT_CHAT.set('socketId', self.socket.id);

			clearInterval(ENGT_CHAT.get('config')?.ackTimer);
			clearTimeout(ENGT_CHAT.get('config')?.ackTimeout);
		});
	};

	disconnect = function () {
		return this.socket?.disconnect();
	};

	onSocketDisconnect = function () {
		const ref = this;

		return this.socket.on('disconnect', () => {
			LOGGER('Socket dis---connected', ENGT_CHAT);

			clearInterval(ENGT_CHAT.get('config')?.ackTimer);
			clearTimeout(ENGT_CHAT.get('config')?.ackTimeout);
			if (readFromLs(LS().GOT_UID) === 'true') {
				ENGT_CHAT.set('config.sessionExpired', false);
			}

			setTimeout(() => {
				if (ENGT_CHAT.get('config.isChatOpened')) {
					clearTimeout(ENGT_CHAT.get('config')?.ackTimeout);

					ref.socket.connect();

					ENGT_CHAT.set(
						'config.ackTimer',
						setInterval(() => {
							if (ENGT_CHAT.get('config.isChatOpened')) {
								LOGGER('Im dis-connected');

								clearTimeout(ENGT_CHAT.get('config')?.ackTimeout);
								ref.socket.connect();

								LOGGER('Trying to connect again');
							} else {
								clearInterval(ENGT_CHAT.get('config')?.ackTimer);
								clearTimeout(ENGT_CHAT.get('config')?.ackTimeout);
							}
						}, 2500)
					);
				}
			}, 500);
		});
	};

	onWebsiteClose = function onWebsiteClose() {
		const ref = this;
		window.onunload = function onUnload() {
			const tabCounter = parseInt(readFromLs(LS().TAB_COUNTER) ?? 0) - 1;

			if (tabCounter < 1) {
				if (isOldUser()) {
					updateChatEvent(false);
				}
				ref.socket.disconnect();
				writeToLs(LS().TAB_COUNTER, 0);
			} else {
				writeToLs(LS().TAB_COUNTER, tabCounter);
			}

			if (ENGT_CHAT.get('config.is_crm_update')) {
				ref.socket.emit('close_chat_widget', {
					user_id: ENGT_CHAT.get('status.sessionKey'),
					bot_key: ENGT_CHAT.get('config.bot_key'),
				});
				ref.socket.disconnect();
			}
		};
	};

	onSocketError = function () {
		const ref = this;
		this.socket.on('error', (error) => {
			LOGGER('Socket errored out', error);
			ref.socket.disconnect();
		});
	};

	onSocketConnectError = function () {
		const ref = this;
		this.socket.on('connect_error', () => {
			LOGGER('Socket connect errored out');
			ref.socket.io.opts.transports = ['polling', 'websocket'];
		});
	};

	emitEvent = function (event, data, ...args) {
		return this.socket.emit(event, data, ...args);
	};

	emitAskUserId = function (launchScreen = ENGT_CHAT.get('config.isLaunchScreenEnabled')) {
		LOGGER('in emit ask user id', launchScreen);
		return this.socket.emit('ask_userid', {
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
			launch_screen: launchScreen,
			session_expired: ENGT_CHAT.get('config.sessionExpired'),
		});
	};

	onAskUserId = function () {
		return this.socket.on('ask_userid', () => {
			LOGGER('in ask_userid');
			emitAskUserIdEvent();
			ENGT_CHAT.set('config.sessionExpired', true);
		});
	};

	gotUserId = function () {
		return this.socket.on('got_userid', () => {
			LOGGER('in got_userid');
			// remove initialization alert when user connected
			// document.getElementsByClassName('engt-icon-name-container')[0].style.padding = '20px 20px 1px 0px';
			// var initializationDiv = document.getElementById('engati-intialization');
			// utils.addClass(initializationDiv, 'engt-hide-element');
			// ENGT_CHAT.removeTypingIndicator();
			// document.getElementById('txMessage').disabled = false;
		});
	};

	onWelcomeMsg = function (
		isWelcomeMsgEmit,
		launchScreen,
		launchFlowKey,
		additionalAttributes,
		postbackText,
		botMessages
	) {
		const ref = this;
		const isLaunchScreen = launchScreen && ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET;
		const isStandalone = ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE;
		const socketName = isLaunchScreen ? 'launch_screen' : 'welcome_msg';

		const generateMsgBody = () => {
			let allAttributes = null;
			if (ENGT_CHAT.get('config.user_attributes')) {
				allAttributes = [].concat(ENGT_CHAT.get('config.user_attributes'));
			}
			if (additionalAttributes) {
				allAttributes = (allAttributes || []).concat(additionalAttributes);
			}
			const webUrl = window.location.href;
			const webPage = document.title;
			const payload = getUserWebAttributeObject(webUrl, webPage);
			const concatedAttributes = (allAttributes || []).concat(payload);
			const launchFlow = launchFlowKey || ENGT_CHAT.get('config.launch_flow');

			const welcomeMsgEmit = {
				key: ENGT_CHAT.get('config.key'),
				user_id: ENGT_CHAT.get('status.sessionKey'),
				attributes: concatedAttributes,
				bot_key: ENGT_CHAT.get('config.bot_key'),
				welcome_msg_flag: ENGT_CHAT.get('config.welcome_msg'),
				first_time: ENGT_CHAT.get('firstTime'),
				launch_flow: launchFlow,
				launch_screen_flag: launchScreen,
				timezone: String(-new Date().getTimezoneOffset() / 60),
				web_url: webUrl,
				web_page: webPage,
				postback_text: postbackText,
				bot_messages: botMessages,
			};

			launchScreen = false;
			launchFlowKey = '';
			additionalAttributes = '';
			postbackText = '';
			botMessages = '';

			return welcomeMsgEmit;
		};

		const updateAcknowledgment = () => {
			const ackMessageMap = ENGT_CHAT.get('ackMessageMap');
			for (const ack in ackMessageMap) {
				const user_msg = {
					bot_key: ENGT_CHAT.get('config.bot_key'),
					message: ackMessageMap[ack]['message'],
					user_id: ENGT_CHAT.get('status.sessionKey'),
					ack,
					key: ENGT_CHAT.get('config.key'),
					is_debug: ENGT_CHAT.get('config.is_debug'),
				};
				ref.emitEvent('user_msg', user_msg);
				delete ackMessageMap[ack];
			}
			ENGT_CHAT.set('ackMessageMap', ackMessageMap);
		};

		const setLaunchScreenVisited = () => {
			ENGT_CHAT.set('config.welcome_msg', false);
			ENGT_CHAT.set('config.launch_flow', false);
		};

		const onWelcomeMsgCb = function (data) {
			writeToLs(LS().GOT_UID, 'true');
			const isLiveChat = readFromLs(LS().LIVECHAT) === 'true';
			LOGGER('in init socketEvent msg', socketName, isLiveChat);

			if (isStandalone && isLiveChat) {
				updateAcknowledgment();
			} else {
				updateAcknowledgment();
			}
			isWelcomeMsgEmit && emitWelcomeMsg(generateMsgBody(), data);
			setLaunchScreenVisited();
		};

		this.socket.off(socketName);
		return this.socket.on(socketName, onWelcomeMsgCb);
	};

	updateAttribute = function updateAttribute(attributes = []) {
		if (!attributes?.length) {
			return;
		}

		const webUrl = window.location.href;
		const webPage = document.title;
		const isLaunchScreen = ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET;

		const welcomeMsgEmit = {
			key: ENGT_CHAT.get('config.key'),
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
			first_time: false,
			timezone: String(-new Date().getTimezoneOffset() / 60),
			launch_screen_flag: isLaunchScreen,
			attributes,
			web_url: webUrl,
			web_page: webPage,
		};

		emitWelcomeMsg(welcomeMsgEmit, {});
	};

	askUserName = function () {
		this.socket.emit('manage_user_name', {
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
			message: { type: 'ask_user_name' },
		});
	};

	playLiveChatNotfication = function (data) {
		if (readFromLs(LS().LIVECHAT) === 'true' && ENGT_CHAT.get('config.is_agent_notifications_enabled')) {
			playLiveChatNotfication(data);
		}
	};

	onBotResponse = function () {
		return this.socket.on('bot_response', (data) => {
			if (ENGT_CHAT.get('config.isAnimating')) {
				// pendingMessages.push(data)
				document.getElementById('txMessage').disabled = true;
			} else {
				const dataObj = JSON.parse(data);
				playLiveChatNotfication(dataObj);
				botResponse(dataObj);
			}
		});
	};

	changeChatStatus = function (text, status) {
		return this.socket.emit('chat_status_change', {
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
			message: { text, type: 'chat_status_change', isOpen: status },
			localStorage: {
				NEW_SESSION: readFromLs(LS().NEW_SESSION),
				LIVECHAT: readFromLs(LS().LIVECHAT),
				PREV_MESSAGES: readFromLs(LS().PREV_MESSAGES),
				IS_NOTIFED: readFromLs(LS().IS_NOTIFED),
				GOT_UID: readFromLs(LS().GOT_UID),
				TAB_COUNTER: readFromLs(LS().TAB_COUNTER),
				SCREEN_TYPE: ENGT_CHAT.get('currentScreen'),
			},
		});
	};

	getAttachmentTransactionId = function () {
		return this.socket.emit('generate_transaction_id', {
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
			message: { text: 'generate_transaction_id', type: 'generate_transaction_id' },
		});
	};

	onAttachmentTransId = function () {
		return this.socket.on('transaction_id_received', (data) => {
			const dataObj = JSON.parse(data);
			const { transaction_id } = dataObj;
			ENGT_CHAT.set('attachmentTransactionId', transaction_id);
		});
	};

	onChatHistoryMsgs = function () {
		return this.socket.on('chat_history_publish', (data) => {
			chatHistoryPublish(JSON.parse(data));
		});
	};

	onLocaleChange = function () {
		return this.socket.on('user_locale_change', (data) => {
			LOGGER('in user_locale_change', data);

			data = JSON.parse(data);
			const userLocale = data['locale'];
			const langCode = userLocale && userLocale.split('-')[0];

			updateBotLanguageToLS(langCode);
			if (ENGT_CHAT.get('config.botLanguage') !== langCode) {
				ENGT_CHAT.set('config.botLanguage', langCode);
				getGenericStringsAndBotConfig();
			}
		});
	};
}

export default EngtSocket;
